const AFFILIATE = {
  INTRO_TITLE: 'Collaboration in Sales',
  INTRO_SUB_TITLE: "Partnership in Raychat's Income",
  INTRO_DESC: `
  If you are active in the web design field or have many friends in this area, you can earn income for yourself through affiliate marketing with Raychat. To collaborate in sales with Raychat, after registering on our website, you will be given a referral code. You can share this code with anyone you think needs Raychat for their website so that they can join Raychat using that code and benefit from it. Every person who purchases Raychat support packages through your referral code will earn 20% of the sales profit on their first purchase and 10% of the sales profit on subsequent purchases and renewals. These percentages are stored in the Raychat wallet option on the dashboard, and you can withdraw your earnings in cash whenever you like or use them to renew your Raychat package.
  `,
  LINK_INTRO_TITLE: 'Invitation Link',
  LINK_INTRO_DESC:
    'Having this referral code makes you a Raychat ambassador, allowing you to invite more people to use Raychat and make it easier for them to access their business support services. To use this code, simply copy your unique link from the box below. Please note that this code is permanent and exclusive to you, and you can monitor how many people have used your referral code through the dashboard.',
  LINK_INPUT_TITLE: 'Copy the link and share with your friends',
  BENEFIT_TITLE: 'profit on your purchase',
  BENEFIT_TITLE_DESC: '10% profit on subsequent purchases',
  BENEFIT_BOX_ALL: 'All your registrations',
  BENEFIT_BOX_PURCHASE_NUM: 'Number of packages purchased',
  BENEFIT_BOX_INCOME: 'Your income from sales',
  BENEFIT_BOX_INCOME_CURRENCY: 'Dollar',
  BENEFIT_BOX_REGISTERS_UNIT: 'Registrations',
  BENEFIT_BOX_PACKAGES_UNIT: 'Packages',

  COPY_CLICK_TOOLTIP: 'Click to copy!',
  LINK_COPIED_MSG: 'Copied!',

  SALES_REPORT_TAB: 'Sales Reports',
  CHECKOUT_TAB: 'Settlement Reports',
  SALES_REPORT_DESC:
    'In this section, you can see the purchase statistics of users who bought through your link in the Raychat package along with details and the amount of their profit from each purchase.',
  SALES_REPORT_NOTFOUND: 'No results were found!',
  SALES_REPORT_NOTFOUND_DESC:
    'In this section, you can see the statistics of cooperation.',

  PAYMENT_TITLE: `
  When your monthly income in Raychat reaches at least 500 dollar, you can register your account settlement request. Then our experts will contact you to settle the account. You can have 'only one active request' for account settlement at any time and it is not possible to send multiple requests at the same time.
  `,
  PAYMENT_AMOUNT: 'Payment Amount',
  ACCOUNT_INFO: 'Account Info',
  ACCOUNT_INFO_DESC: 'Enter your account info for settlement',
  ACCOUNT_NUM_PLACEHOLDER: 'Card number',
  ACCOUNT_OWNER_PLACEHOLDER: "Account owner's name",
  BANK_PLACEHOLDER: 'Bank Name',
  PAYMENT_RESULT_TITEL: 'No result found!',
  PAYMENT_RESULT_DESC: `
  In this section, you can see the statistics of cooperation.
  `,
  SETTLEMENT_REQ_BTN: 'Settlement Request',
  SUBMIT_INFO_BTN: 'Submit Info',
  CURRENCY_SUFFIX: 'Dollar',

  ACCOUNT_INFO_NOT_CORRECT_ERROR: 'Account info is not correct',
  MIN_SETTLEMENT_AMOUNT_ERROR: 'Minimum settlement amount is 500 dollars',
  MIN_SHEBA_LENGTH_ERROR: "SHEBA number's length should be at least 24",

  CHART_TOOLTIP_INCOME: 'Income',
  AFFILIATE_WITH_RAYCHAT: 'Affiliation System In Raychat',
  KNOW_MORE: 'Learn more',
  STATISTICS_TITLE: 'Statistics',
  MORE_INFO_BOX_TITLE: 'Number of users to date',
};

export default AFFILIATE;
